import type { SVGProps } from 'react';
const SvgPheasant = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" {...props}>
    <path d="M32.567 10.682a.566.566 0 0 1 .519-.825H34.5l-.943-1.508a1.79 1.79 0 0 0-1.414-.849h-.896c-.423 0-.832.15-1.155.424l-1.65 1.202h.967l-.92 3.018L1.5 30.34h1.556L22.03 19.78l3.795 1.791v2.357l-.613.778h3.606a.754.754 0 0 0-.754-.778h-1.461v-2.357l3.3-1.414a6.223 6.223 0 0 0 3.182-8.392z" />
  </svg>
);
export default SvgPheasant;
